import React from 'react';

import type { PaymentActor } from '../../../generated-types';
import useTranslation from '../../../hooks/useTranslation';
import TransactionLine from './TransactionLine';

interface Props {
    approvers?: PaymentActor[];
}

const TransactionApprovers: React.FC<Props> = ({ approvers }) => {
    const translated = useTranslation();

    const uniqueApprovers = approvers?.filter(
        (value, index, self) => self.findIndex((item) => item.name === value.name) === index,
    );
    if (!uniqueApprovers) return <></>;
    if (uniqueApprovers.length === 1) {
        return <TransactionLine value={uniqueApprovers[0].name} label={translated.transactionDetails.singleApprover} />;
    }
    return (
        <>
            {uniqueApprovers.map((approver) => (
                <TransactionLine
                    key={approver.name}
                    value={approver.name}
                    label={
                        approver.type === 'CREATOR'
                            ? translated.transactionDetails.approvers.createdBy
                            : translated.transactionDetails.approvers.approvedBy
                    }
                />
            ))}
        </>
    );
};
export default TransactionApprovers;
